import { AvailableSettings, BulkEmailExemptPolicy } from 'types/Settings'

type ClassificationResultNew = { classification: 'NEW'; item: Record<string, any> }
type ClassificationResultModified = {
  classification: 'MODIFIED'
  item: Record<string, any>
  existing: Record<string, any>
}
type ClassificationResultUnchanged = { classification: 'UNCHANGED'; existing: Record<string, any> }

type ClassificationResult = ClassificationResultNew | ClassificationResultModified | ClassificationResultUnchanged

export function classifyBulkEmailExemptItem(
  item: BulkEmailExemptPolicy,
  existing: Record<string, any> | undefined
): ClassificationResult {
  if (!existing) {
    return { classification: 'NEW', item }
  }

  if (item.comment !== existing.comment) {
    return { classification: 'MODIFIED', item, existing }
  }

  return { classification: 'UNCHANGED', existing }
}
